import { httpInterceptor } from '../http-interceptor';

export class PartService {
  static ENDPOINTS = {
    GET_ALL: 'Mobile/getPartsForQualityAlert',   
    GET_ALL_PARTS: 'Part/getall',
    GET_PARTS_FOR_INSPECTION_PLAN: 'Mobile/getPartsForQualityAlert', // Same endpoint but with status filter
    GET_ALL_PARTS_FOR_QUALITY_INSPECTION: 'Part/getAllPartsForQualityInspection', // New endpoint for Quality Inspection
    ADD_PART: 'Part/savepart',
    UPLOAD_DRAWING: 'Customer/Upload',
    GET_PART_DETAILS_BY_ID: 'Part/getbyid/',
  };

  static async getAllParts(data) {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL,data);
  }
  static async getPartsForInspectionPlan(status = 'In Production') {
    return httpInterceptor.get(this.ENDPOINTS.GET_PARTS_FOR_INSPECTION_PLAN, { status });
  }
  static async getAllPartsForQualityInspection() {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL_PARTS_FOR_QUALITY_INSPECTION);
  }
  static async getAllPartsList() {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL_PARTS);
  }
  static async AddPart(data) {
    return httpInterceptor.post(this.ENDPOINTS.ADD_PART, data);
  }
  static async uploadDrawing(data) {
    return httpInterceptor.postfile(this.ENDPOINTS.UPLOAD_DRAWING, data);
  }
  static async getPartDetailsById(id) {
    return httpInterceptor.get(this.ENDPOINTS.GET_PART_DETAILS_BY_ID + id);
  }
  
}
